module.exports = __webpack_public_path__ + "static/img/areaA-1.206a3a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-1.png
// module id = 920
// module chunks = 1